<template>
  <v-list-item link @click="onCapture" :disabled="!permission">
    <v-list-item-title> Screenshot </v-list-item-title>
    <v-list-item-icon>
      <v-icon>mdi-monitor-screenshot</v-icon>
    </v-list-item-icon>
  </v-list-item>
</template>

<script>
export default {
  name: "screenShot",
  data() {
    return {
      menu: false,
    };
  },
  props: {
    permission: undefined,
    remoteVideoRef: undefined,
  },
  methods: {
    onCapture() {
      var canvas = document.createElement("canvas");
      const height = window.innerHeight - 100;
      const width = window.innerWidth - 100;
      canvas.width = width;
      canvas.height = height;
      canvas
        .getContext("2d")
        .drawImage(this.remoteVideoRef, 0, 0, width, height);
      var data = canvas.toDataURL("image/png");
      var a = document.createElement("a"); //Create <a>
      a.href = data; //Image Base64 Goes here
      a.download = "Image.png"; //File name Here
      a.click(); //Downloaded file
    },
  },
};
</script>
